import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    CreateFormTypeBody,
    UpdateFormTypeBody,
    FormTypeResponse,
    createFormType,
    updateFormType,
    deleteFormType,
} from '../../services/apiSLTP/qhse/forms/formTypes';

type UseUpdateFormTypeMutationOptions = MutationOptions<FormTypeResponse, Error, { formTypeId: string; data: UpdateFormTypeBody }>;

type UseCreateFormTypeMutationOptions = MutationOptions<FormTypeResponse, Error, CreateFormTypeBody>;

type UseDeleteFormTypeMutationOptions = MutationOptions<{ message: string }, Error, { formTypeId: string }>;

export const useUpdateFormTypeMutation = (options?: UseUpdateFormTypeMutationOptions) => {
    const mutation: MutationFunction<FormTypeResponse, { formTypeId: string; data: UpdateFormTypeBody }> = async ({ formTypeId, data }) => {
        try {
            const response = await updateFormType(formTypeId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during updateFormType');
        }
    };

    return useMutation(mutation, options);
};

export const useCreateFormTypeMutation = (options?: UseCreateFormTypeMutationOptions) => {
    const mutation: MutationFunction<FormTypeResponse, CreateFormTypeBody> = async (data) => {
        try {
            const response = await createFormType(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during createFormType');
        }
    };

    return useMutation(mutation, options);
};

export const useDeleteFormTypeMutation = (options?: UseDeleteFormTypeMutationOptions) => {
    const mutation: MutationFunction<{ message: string }, { formTypeId: string }> = async ({ formTypeId }) => {
        try {
            const response = await deleteFormType(formTypeId);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during deleteFormType');
        }
    };

    return useMutation(mutation, options);
};
